/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Manager가 스프린트에서 계약 이전에 오리엔테이션 수료 여부 상태
 */
export type ManagerOrientationStatusType = 'Pending' | 'Completed';

export const ManagerOrientationStatusType = {
    Pending: 'Pending' as ManagerOrientationStatusType,
    Completed: 'Completed' as ManagerOrientationStatusType
};

